/* eslint-disable no-console */
import { LogEntry, LogLevel } from './types';
import { serialize } from './utils';

export function defaultLogMethod(e: LogEntry): void {
  const timestamp = new Date();
  const { level, data, ...entryProps } = e;
  if (level === LogLevel.Trace) {
    console.groupCollapsed(e.context, e.message);
    console.log(timestamp);
    console.trace(typeof data === 'function' ? data() : data);
    console.groupEnd();
    return;
  } else {
    const entry = {
      ...entryProps,
      data: serialize(data),
      level,
      timestamp: timestamp,
    };
    switch (level) {
      case LogLevel.Fatal:
        console.error(entry);
        break;
      case LogLevel.Error:
        console.error(entry);
        break;
      case LogLevel.Warn:
        console.warn(entry);
        break;
      case LogLevel.Info:
        console.info(entry);
        break;
      case LogLevel.Debug:
        console.debug(entry);
        break;
      default:
        console.log(entry);
        break;
    }
  }
}
